export default __webpack_public_path__ + "static/media/newlanplace.83400a3f.png";